import { createContext, type Context } from 'react';

import type { SessionListSession } from '@atlassian/rovo-platform-ui-components/session-list/SessionListItem';

/** Presentation-only data supplied once by the navigation owner; rows never fetch sessions. */
export type NavigationAgentSession = Pick<
	SessionListSession,
	'state' | 'conversationChannel' | 'displayAgent' | 'lastStateChangeAt'
>;

export const NavigationAgentSessionsContext: Context<ReadonlyMap<string, NavigationAgentSession>> =
	createContext<ReadonlyMap<string, NavigationAgentSession>>(new Map());
